import { confirmModal } from '@/utils/misc/modal'

async function confirmClickHandler(event) {
  event.preventDefault()
  try {
    await confirmModal(this.config.title || 'Yellowbrick Manager', this.config.message || 'Are you sure you want to perform this operation?')
    this.config.onConfirm(true)
  } catch (ignore) {
  }
}

export default function(app) {
  app.directive('yb-confirm', {
    beforeMount(el, binding, vnode) {
      // Start with directive value
      const cfg = {}
      if (typeof binding.value === 'function') {
        cfg.onConfirm = binding.value
      } else if (binding.value && typeof binding.value === 'object') {
        Object.assign(cfg, binding.value)
      }

      // Pull from vnode props if present
      const props = vnode.props || {}
      if (props.title != null) { cfg.title = cfg.title ?? props.title }
      if (props.message != null) { cfg.message = cfg.message ?? props.message }

      // Fallback to actual DOM attributes (works great on native elements)
      const attr = name =>
        el.getAttribute(name) ?? el.getAttribute(`data-${name}`)
      cfg.title = cfg.title ?? attr('title')
      cfg.message = cfg.message ?? attr('message')

      const handler = confirmClickHandler.bind({ config: cfg })
      el.__ybConfirmHandler = handler
      el.addEventListener('click', handler)
    },
    unmounted(el, binding, vnode) {
      if (el.__ybConfirmHandler) {
        el.removeEventListener('click', el.__ybConfirmHandler)
        delete el.__ybConfirmHandler
      }
    }
  })
}
